import { SITE_IMAGES, veilGradient } from "src/config/images";

// ФОТОПОЛОСА В СЕРЕДИНЕ СТРАНИЦЫ.
//
// Зачем. Фотографии на сайте стояли только по краям: кадр в шапке и кадр в
// подвале. Между ними тянулась ровная тёмная заливка — на длинных страницах
// (все туры, услуги, о нас) середина выглядела пустой, а на короткой
// странице с одним-двумя турами пустота занимала пол-экрана.
//
// Полоса решает это, не мешая читать: фотография лежит подложкой, её края
// растворяются в фоне страницы (маска photo-fade-both), а поверх — плотная
// тёмная вуаль. Видно ровно настолько, чтобы глаз зацепился за глубину,
// но текст и рамки карточек остаются контрастными.
//
// КАК ПОЛЬЗОВАТЬСЯ:
//   родителю — `relative`, содержимому — `relative z-10`, иначе полоса
//   ляжет поверх текста:
//
//     <div className="relative">
//       <PhotoBand className="top-40" />
//       <div className="relative z-10"> … </div>
//     </div>
//
// Положение и высота задаются классами снаружи (`top-…`, `h-…`) — так одна
// и та же полоса подходит и длинной странице, и короткой.
//
// ФОТО меняется в src/config/images.js. По умолчанию берём кадр блока туров:
// он тёплый и тёмный, под вуалью читается как глубина, а не как картинка.
export default function PhotoBand({
  image = SITE_IMAGES.activities,
  className = "top-0 h-[440px] sm:h-[560px]",
  // Отражение по горизонтали. Разных кадров в src/assets/site/ всего два, и
  // фото подвала — тот же снимок, что чаще всего идёт в полосу. Без зеркала
  // одни и те же ворота видны на странице дважды подряд; отражённый кадр под
  // плотной вуалью читается как другой ракурс, а не как повтор.
  mirrored = false,
}) {
  return (
    <div
      aria-hidden="true"
      className={`pointer-events-none absolute inset-x-0 overflow-hidden photo-fade-both ${className}`}
    >
      <img
        src={image}
        alt=""
        className={`h-full w-full object-cover ${mirrored ? "-scale-x-100" : ""}`}
      />
      {/* Плотность вуали — один параметр PHOTO_VEIL на весь сайт
          (src/config/images.js). Раньше она была зашита здесь классами
          Tailwind, и фотографию «уводило назад» без возможности подкрутить. */}
      <div className="absolute inset-0" style={{ backgroundImage: veilGradient() }} />
    </div>
  );
}
